<div [class]="color" [class.remove]="removeIcon" (click)="onClick($event)">
    <p>
        <ng-content></ng-content>
        <fa-icon *ngIf="removeIcon" [icon]="faTimes" (click)="onRemove()"></fa-icon>
    </p>
</div>